<nz-card>
  <nz-spin [nzSpinning]="loading">
    <form nz-form [formGroup]="validateForm">
      <div nz-row style="height: 40px;">
        <nz-form-item>
          <nz-form-label>
            <div style="width: 100%;" class="width-100-percent label-font">{{ "WaitingAgentNumber" | translate}}
            </div>
          </nz-form-label>
          <nz-form-control>
            <nz-select [nzServerSearch]="true" formControlName="buyerId" (nzOnSearch)="userSearch($event)"
              style="border-radius:6px;width: 200px;" nzPlaceHolder="{{'inputvalue'|translate}}" [nzAllowClear]="true"
              [nzShowSearch]="true" (ngModelChange)="changeSelect($event)">
              <nz-option *ngFor="let o of userOptionList" [nzValue]="o.userId" nzLabel="{{o.userId}}/{{o.englishName}}"
                nzCustomContent>
                <span>{{o.userId}}/{{o.englishName}}</span>
              </nz-option>
            </nz-select>
          </nz-form-control>
          <!-- <nz-form-control nzSpan="16">
          <input nz-input formControlName="applyDept"                   " />
        </nz-form-control> -->

          <div nz-row style="margin-left: 60px;">
            <div nz-col nzSpan="4" nzPush="4">
              <button nz-button nzType="primary" class="default-button" (click)="exportTableToExecl()"><span nz-icon
                  nzType="download" nzTheme="outline"></span>{{'DownloadExcel'|translate}}</button>
            </div>
            <div nz-col nzSpan="4" nzPush="16">
              <nz-upload [nzFileList]="fileList" [nzBeforeUpload]="beforeUpload">
                <button nz-button class="upload-button default-button">
                  <em nz-icon nzType="upload"></em>{{'UploadExcel'|translate}}
                </button>
              </nz-upload>
            </div>
          </div>

        </nz-form-item>

      </div>
    </form>


    <div style="width: 100%;">
      <nz-table #colSpanTable [nzData]="listOfData" style="margin-bottom: 10px" nzSize="middle" nzShowSizeChanger
        [nzFrontPagination]="false" [nzShowPagination]="false" [nzPageSize]="pageSize" [nzPageIndex]="pageIndex"
        [nzScroll]="{ y: '500px', x: '1400px' }" nzTitle='{{ "ProxyHistory" | translate}}'>
        <thead>
          <tr>
            <th scope="col" nzWidth="50px">{{ "FunctionCategory" | translate}}</th>
            <th scope="col" nzWidth="50px">{{ "EmployeeID" | translate }}</th>
            <th scope="col" nzWidth="100px">{{ "EmployeeName" | translate }}</th>
            <th scope="col" nzWidth="50px">{{ "ProxyID" | translate }}</th>
            <th scope="col" nzWidth="100px">{{ "ProxyName" | translate }}</th>
            <th scope="col" nzWidth="50px">{{ "table.ODD" | translate }}</th>
            <th scope="col" nzWidth="50px">{{ "StartDate" | translate }}</th>
            <th scope="col" nzWidth="50px">{{ "EndDate" | translate }}</th>
            <th scope="col" nzWidth="150px">{{ "Remark" | translate }}</th>
            <th scope="col" nzWidth="50px" [nzRight]="true">{{ "act" | translate}}</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let data of colSpanTable.data; let i = index">
            <td>{{data.function}}</td>
            <td>{{data.employeeID}}</td>
            <td>{{data.employeeName}}</td>
            <td>{{data.proxyID}}</td>
            <td>{{data.proxyName}}</td>
            <td>{{data.pono}}</td>
            <td>{{data.startDate}}</td>
            <td>{{data.endDate}}</td>
            <td>{{data.remark}}</td>
            <td style="align-content: center;" *ngIf="!data.status && data.endDate>=dateNow" [nzRight]="true"><span
                nz-icon nzType="edit" nzTheme="outline" (click)="onEdit(data)"></span></td>
            <td *ngIf="data.status">Canceled</td>
            <td *ngIf="!data.status && dateNow>data.endDate"></td>
          </tr>
        </tbody>
      </nz-table>
      <nz-pagination style="float: right" [(nzPageIndex)]="pageIndex" [nzTotal]="nzTotal" [nzSize]="'small'"
        nzShowSizeChanger [nzPageSizeOptions]="[10, 20, 50,100]" [nzPageSize]="pageSize"
        (nzPageSizeChange)="nzPageSizeChange($event)" (nzPageIndexChange)="nzPageIndexChange($event)">
      </nz-pagination>
      <ng-template #renderItemTemplate let-type let-page="page">

        <a *ngIf="type === 'page'">{{ page }}</a>
        <a *ngIf="type === 'prev'" [style.color]="'black'">&#60;</a>
        <a *ngIf="type === 'next'" [style.color]="'black'">&#62;</a>
      </ng-template>
    </div>

    <app-add-edit-proxy *ngIf="isEdit" [isEdit]="true" [editData]="editData" (close)="closeAdd()"
      (save)="saveEdit($event)" (Cancel)="GetCancelFlag($event)"></app-add-edit-proxy>
  </nz-spin>
</nz-card>